
/* injects from baggage-loader */

'use strict'
import { find, chain, fill, concat, findIndex } from 'lodash';
import html2canvas from 'html2canvas';

import { initFeedbackTexts, feedbackTexts, feedbackFinishStage, helpTpl } from './stage-four.const';

// Generate array with 4 bottom position, and 11 right position
export const botSequence = concat(['right'], concat(fill(Array(4), 'bottom')), concat(fill(Array(10), 'right')));
//export const botSequence2 = concat(['right'], concat(fill(Array(4), 'bottom')), concat(['right']), concat(fill(Array(2),'top')), concat(fill(Array(2), 'right')), concat(['bottom']), concat(fill(Array(6), 'right')));

export default class StageFourController {
    constructor($log, $state, $rootScope, $timeout, TamanduaCanvas, Dialog, Trophies, Session) {
        'ngInject';
        this.name = "Stage 4";
        this.$log = $log;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.TamanduaCanvas = TamanduaCanvas;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;

        this.players = [];
        this.hasRuler = false;
        this.canvasDisabled = true;
        this.tamanduaLetters = ["A", "B"];
    }

    $onInit() {
        this.rowsNumber = 5;
        this.columnsNumber = 10;

        let updates = this.Session.get();
        let stageIndex = findIndex(updates.stages, { name: this.name });

        this.canvasInit(0);

        updates.stages[stageIndex].timesEntered++;
        //let tamanduaBot = document.getElementById


        this.Dialog.showFeedbackIbama('label-tamandua', initFeedbackTexts, () => {
            if (updates.stages[stageIndex].firstRun) {
                updates.stages[stageIndex].firstRun = false;
                this.Session.save(updates);
                this.openHelp(() => this.canvasDisabled = false);
            }
            else {
                this.Session.save(updates);
                this.canvasDisabled = false;
            }
        });
    }

    openHelp(callback) {
        this.Dialog.showBigAlert('label-help', helpTpl, callback);
    }
    /*
    canvasInit() {
        this.squads = this.TamanduaCanvas.createCanvas()
        // Type = B, isNull = true
        this.players[0] = this.TamanduaCanvas.createPlayer("A", true);
        this.players[1] = this.TamanduaCanvas.createPlayer("B", true);

        this.players[0].onDone = this.onFisrtPlayerDone.bind(this);
        this.players[1].onDone = this.onLastPlayerDone.bind(this);
    }
    */

    canvasInit(index) {
        if (index === 0)
            this.squads = this.TamanduaCanvas.createCanvas();
        this.players[index] = this.TamanduaCanvas.createPlayer(this.tamanduaLetters[index], true);
        //this.players[index].onDone = this.onFisrtPlayerDone.bind(this);
        //this.players[index].onDone = this.onLastPlayerDone.bind(this);


        if (index === 1) {
            this.players[index].onDone = this.onLastPlayerDone.bind(this);
        } else {
            this.players[index].onDone = this.onFisrtPlayerDone.bind(this);
        }

    }

    onFisrtPlayerDone() {
        html2canvas(document.getElementById('stage-container'), { ignoreElements: true, imageTimeout: 200 }).then(canvas => {
            let snapshot = canvas.toDataURL('image/png', 0.25);
            this.Dialog.showFeedback('label-very-good', feedbackTexts, 'btn-continue', this.onShowFeedbackSuccess.bind(this, snapshot));
        });
    }

    onLastPlayerDone() {
        let model = {
            players: this.players
        }

        html2canvas(document.getElementById('stage-container'), { ignoreElements: true, imageTimeout: 200 }).then(canvas => {
            let snapshot = canvas.toDataURL('image/png', 0.25);
            model.snapshot = snapshot;

            this.Dialog.showQuizTamanduaC(model, () => {
                this.Trophies.collectThrophies('default', 'tamandua');
                this.Trophies.collectThrophies('emblem', 'tamandua');

                this.Dialog.showTrophy('tamandua', feedbackFinishStage, () => {
                    let infos = this.Session.get();
                    infos.stages[3].totalCompleted++;
                    this.Session.save(infos);
                    this.$state.go('main');
                });
            })
        });
    }

    onShowFeedbackSuccess(snapshot) {
        let model = {
            player: find(this.players, { selected: true }),
            snapshot
        }

        this.Dialog.showQuizTamandua(model, this.onQuizTamanduaSuccess.bind(this));
    }

    onQuizTamanduaSuccess() {
        this.hasRuler = true;

        let items = chain(this.squads)
            .filter(s => s.objects.length, s => s.selectable)
            .uniqBy("objects")
            .shuffle()
            .take(3)
            .value();

        items.forEach(i => i.selected = true);

        let model = {
            player: find(this.players, { selected: true }),
            squads: this.squads,
            items: items
        }

        this.isCounterHidden = true;

        this.$timeout(() => {
            html2canvas(document.getElementById('stage-container'), { ignoreElements: true, imageTimeout: 200 }).then(canvas => {
                let snapshot = canvas.toDataURL('image/png', 0.25);
                model.snapshot = snapshot;
                this.Dialog.showQuizTamanduaB(model, this.onQuizTamanduaBSuccess.bind(this));
            });
        }, 3000);
    }

    onQuizTamanduaBSuccess() {
        this.Trophies.collectThrophies('default', 'tamandua');
        this.Trophies.collectThrophies('emblem', 'tamandua');

        this.Dialog.showTrophy('tamandua', feedbackFinishStage, () => {
            let infos = this.Session.get();
            infos.stages[3].totalCompleted++;
            this.Session.save(infos);
            this.$state.go('main');
        });

        /*
        this.canvasInit(1);
        this.hasRuler = false;
        this.$rootScope.$emit('tamandua-canvas:select:player', 1); // select second tamandua
        this.$rootScope.$emit('tamandua-canvas:start:bot', botSequence); // select second tamandua
        */

        /*
        if(this.getTotalSteps(this.players[0]) == 14){
            this.$rootScope.$emit('tamandua-canvas:start:bot', botSequence2); // select second tamandua
        } else {
            this.$rootScope.$emit('tamandua-canvas:start:bot', botSequence); // select second tamandua
        }
        */

    }


    getTotalSteps(player) {
        let total = 0;

        angular.forEach(player.events, attr => {
            total += attr
        });

        return total
    }

    onStageReset() {
        this.canvasInit()
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-four/stage-four.controller.js